import gql from 'graphql-tag'

export const PRODUCTS = gql`
  query Products(
    $unit: String
    $ecommerce: Boolean
    $category: String
    $with_image: Boolean
    $search: String
    $page: Int
    $page_size: Int
    $sort: [String]
    $sort_direction: [SortDirection]
    $categories_final_consumer: ListCategoriesFinalConsumerInput
  ) {
    products(
      unit: $unit
      ecommerce: $ecommerce
      category: $category
      with_image: $with_image
      search: $search
      page: $page
      page_size: $page_size
      sort: $sort
      sort_direction: $sort_direction
      categories_final_consumer: $categories_final_consumer
    ) {
      records
      page
      products {
        _id
        sku
        name
        ean
        eans
        image
        updated_at
        category {
          _id
          name
          image
        }
        categories_final_consumer {
          department {
            _id
            name
            image
          }
          category {
            _id
            name
            image
            department_id
          }
          sub_category {
            _id
            name
            image
            category_id
          }
        }
        type
        basis_weight
      }
    }
  }
`

export const PRODUCT = gql`
  query Product($ean: String, $sku: String) {
    product(ean: $ean, sku: $sku) {
      sku
      ean
    }
  }
`

export const PRODUCT_CATEGORIES = gql`
  query ProductCategories {
    productCategories {
      _id
      name
      image
    }
  }
`

export const UPDATE_PRODUCT = gql`
  mutation UpdateProduct($data: UpdateProductInput!) {
    updateProduct(data: $data) {
      _id
      sku
      name
      ean
      image
      updated_at
      category {
        _id
        name
        image
      }
      type
      basis_weight
    }
  }
`

export const CREATE_PRODUCT = gql`
  mutation CreateProduct($data: CreateProductInput!) {
    createProduct(data: $data) {
      _id
      sku
      name
      ean
      image
      updated_at
      category {
        _id
        name
        image
      }
      categories_final_consumer {
        department {
          _id
          name
          image
        }
        category {
          _id
          name
          image
          department_id
        }
        sub_category {
          _id
          name
          image
          category_id
        }
      }
      type
      basis_weight
    }
  }
`

export const BULK_UPSERT_PRODUCT = gql`
  mutation BulkUpsertProducts($file: Upload!, $columns: ProductFileColumns!, $update_preexisting: Boolean!, $fill_missing_eans: Boolean!) {
    bulkUpsertProducts(file: $file, columns: $columns, update_preexisting: $update_preexisting, fill_missing_eans: $fill_missing_eans) {
      total_number_of_lines
      failure {
        failed_lines_examples {
          line_no
          sku
          ean
          name
          reason
        }
        total_failures
      }
      success {
        products_created
        products_updated
        products_without_image
        products_without_ean
        products_without_image_skus
      }
    }
  }
`

export const REQUEST_PRODUCTS_GROUPS_BULK_UPSET = gql`
  mutation RequestProductsGroupsBulkUpsert($file: Upload!, $columns: ProductFileColumns!, $updatePreexisting: Boolean!) {
    requestProductsGroupsBulkUpsert(file: $file, columns: $columns, updatePreexisting: $updatePreexisting) {
      actionsPreview {
        groupsToUpdate
        groupsToCreate
      }
      dataFileURL
      failureLinesQuantity
      failureLines {
        lineNumber
        name
        sku
        ean
        reason
      }
    }
  }
`

export const CONFIRM_PRODUCTS_GROUPS_BULK_UPSERT = gql`
  mutation ConfirmProductsGroupsBulkUpsert($dataFileURL: String!, $updatePreexisting: Boolean!) {
    confirmProductsGroupsBulkUpsert(dataFileURL: $dataFileURL, updatePreexisting: $updatePreexisting)
  }
`

export const QUERY_GET_GROUPS = gql`
  query ProductsGroups($search: String, $sort: [String], $sortDirection: [SortDirection], $page: Int, $pageSize: Int) {
    productsGroups(search: $search, sort: $sort, sortDirection: $sortDirection, page: $page, pageSize: $pageSize) {
      productsGroups {
        _id
        name
        image_url
        rules_exhibition
        category {
          _id
          name
          image
        }
        categories_final_consumer {
          department {
            _id
            name
            image
          }
          category {
            department_id
            _id
            name
            image
          }
          sub_category {
            category_id
            _id
            name
            image
          }
        }
        products_qty
        created_at
        updated_at
        image_url
        rules_exhibition
        categories_final_consumer {
          department {
            _id
            name
          }
          category {
            _id
            name
            department_id
          }
          sub_category {
            _id
            name
            category_id
          }
        }
      }
      page
      records
    }
  }
`

export const PRODUCT_CATEGORIES_FINAL_CONSUMER = gql`
  query CategoriesFinalConsumer($search: String) {
    categoriesFinalConsumer(search: $search) {
      departments {
        _id
        name
        image
      }
      categories {
        _id
        name
        image
        department_id
      }
      sub_categories {
        _id
        name
        image
        category_id
      }
    }
  }
`

export const QUERY_GET_GROUP_PRODUCTS = gql`
  query ProductsGroup($_id: ID!, $active: Boolean) {
    productsGroup(_id: $_id) {
      _id
      name
      products(active: $active) {
        _id
        image
        name
        sku
        ean
        eans
        franchisee_eans_frequency_percentage
        units_with_price_1
      }
      image_url
      rules_exhibition
      category {
        _id
        name
        image
      }
      categories_final_consumer {
        department {
          _id
          name
          image
        }
        category {
          department_id
          _id
          name
          image
        }
        sub_category {
          category_id
          _id
          name
          image
        }
      }
      products_qty
    }
  }
`

export const MUTATION_UPSERT_GROUP_PRODUCTS = gql`
  mutation UpsertProductsGroup($data: UpsertProductsGroupInput!) {
    upsertProductsGroup(data: $data) {
      _id
      name
    }
  }
`
export const MUTATION_DELETE_GROUP_PRODUCTS = gql`
  mutation DeleteProductsGroup($_id: ID!) {
    deleteProductsGroup(_id: $_id)
  }
`

export const QUERY_GROUP_NAME_AVAILABILITY = gql`
  query ProductsGroupNameAvailability($name: String!) {
    productsGroupNameAvailability(name: $name)
  }
`

export const QUERY_GET_BRANDS = gql`
  query Brands($page: Int, $search: String, $pageSize: Int) {
    brands(page: $page, search: $search, pageSize: $pageSize) {
      brands {
        id
        name
        active
      }
      records
    }
  }
`

export const QUERY_GET_CATEGORIES = gql`
  query ListCategory($page: Int, $pageSize: Int, $search: String, $departmentId: ID) {
    listCategory(page: $page, pageSize: $pageSize, search: $search, departmentId: $departmentId) {
      categories {
        id
        name
        active
      }
      page
      records
    }
  }
`

export const QUERY_GET_SUBCATEGORIES = gql`
  query SubCategories($page: Int, $pageSize: Int, $search: String, $categoryId: ID) {
    listSubCategory(page: $page, pageSize: $pageSize, search: $search, categoryId: $categoryId) {
      subCategories {
        id
        name
        active
      }
    }
  }
`

export const QUERY_GET_DEPARTMENTS = gql`
  query ListDepartment($page: Int, $pageSize: Int, $search: String) {
    listDepartment(page: $page, pageSize: $pageSize, search: $search) {
      departments {
        id
        name
        active
      }
      page
      records
    }
  }
`

export const QUERY_GET_PRODUCT_BY_ID = gql`
  query FindProductById($id: ID!) {
    findProductById(id: $id) {
      id
      ecommerceId
      legacySku
      legacyFranchiseSku
      legacyFranchiseOrigins
      catalogId
      productMfId
      departmentId
      cbm
      ecommerce
      departmentMfId
      productMfname
      departmentMf {
        name
      }
      categoryId
      categoryMf {
        name
      }
      categoryMfId
      ecommerceCategoryId
      subcategoryId
      subcategoryMf {
        name
      }
      subcategoryMfId
      brandId
      brandMfId
      brandMf {
        name
      }
      ecommerceBrandId
      isWeightable
      measure {
        name
        acronym
        fractionalSale
        active
      }
      measureMfId
      eans {
        ean
        isMain
        packingQuantity {
          name
          quantityPackaging
          proportionalAmount
          packingUnit
          proportionalUnit
        }
      }
      name
      slug
      images {
        isMain
        url
        urlThumbnail
        urlMiniature
        order
      }
      quantityDescription
      description
      initialWeight
      additionWeight
      nutritionalTable
      isMedicine
      activePrinciple
      leaflet
      deliveryRestriction {
        active
      }
      longName
      keywords
      gpc
      ncm
      height
      width
      depth
      grossWeight
      netWeight
      totalAmountPackaging
      content
      measureContent
      ingredients
      recommendationsForUse
      synonyms {
        ecommerceId
        name
        normalizedName
        soundex
      }
      variations {
        name
        percentage
        isDefault
        ecommerceId
      }
      manuallyEdited
      erpName
      active
      duplicates {
        active
        eans {
          isMain
          ean
          packingQuantity {
            name
            packingUnit
            proportionalAmount
            proportionalUnit
            quantityPackaging
          }
          normalized
        }
        id
        legacySku
        name
      }
      erpCategories {
        erpId
        name
      }
    }
  }
`
export const MUTATION_CLEAN_PRODUCTS_DUPLICATES = gql`
  mutation CleanProductsDuplicates($cleanProductsDuplicatesId: ID!, $eans: [String!]!) {
    cleanProductsDuplicates(id: $cleanProductsDuplicatesId, eans: $eans) {
      editedIds
    }
  }
`
export const QUERY_GET_PRODUCTS = gql`
  query ListProduct($page: Int, $pageSize: Int, $search: String, $filter: FilterListProductsInput) {
    listProduct(page: $page, pageSize: $pageSize, search: $search, filter: $filter) {
      page
      products {
        id
        active
        legacySku
        createdAt
        cbm
        ecommerce
        images {
          url
          urlMiniature
        }
        updatedAt
        catalogId
        name
        eans {
          ean
          isMain
        }
        department {
          name
          id
        }
        manuallyEdited
      }
      records
    }
  }
`

//
export const MUTATION_UPLOAD_IMAGE = gql`
  mutation UploadFile($file: Upload!) {
    uploadFile(file: $file) {
      url
      urlThumb
      urlMini
    }
  }
`

export const QUERY_GET_MEASURES = gql`
  query ListMeasure($pageSize: Int, $page: Int) {
    listMeasure(pageSize: $pageSize, page: $page) {
      measures {
        id
        name
        active
        fractionalSale
        acronym
      }
    }
  }
`

export const MUTATION_CREATE_PRODUCT = gql`
  mutation CreateProduct($data: CreateProductInput!) {
    createProduct(data: $data) {
      id
    }
  }
`

export const MUTATION_UPDATE_PRODUCT = gql`
  mutation UpdateProduct($data: UpdateProductInput!) {
    updateProduct(data: $data) {
      id
    }
  }
`

export const MUTATION_UPLOAD_PRODUCT = gql`
  mutation UploadProducts($file: Upload!, $data: UploadProductsConfigInput!) {
    uploadProducts(file: $file, data: $data) {
      totalNumberOfLines
      failure {
        url
        failedLines {
          ean
          lineNo
          name
          reason
        }
        totalFailures
      }
      success {
        created
        updated
      }
    }
  }
`

export const QUERY_GET_PRODUCT_STORE = gql`
  query StoreProducts($page: Int, $pageSize: Int, $search: String, $filter: FilterListStoreProductsInput) {
    storeProducts(page: $page, pageSize: $pageSize, search: $search, filter: $filter) {
      storeProducts {
        active
        id
        name
        product {
          images {
            isMain
            url
            urlThumbnail
            urlMiniature
          }
        }
        store {
          id
          name
        }
        storeId
        sku
      }
      records
      page
    }
  }
`

export const QUERY_GET_PRODUCT_STORE_BY_ID = gql`
  query StoreProductById($storeProductById: ID!) {
    storeProductById(id: $storeProductById) {
      active
      id
      eans {
        ean
        isMain
        packingQuantity {
          name
          quantityPackaging
        }
      }
      product {
        id
        name
        images {
          isMain
          url
          urlThumbnail
          urlMiniature
        }
      }
      createdManually
      ecommerceId
      name
      order
      price1
      productId
      sales {
        active
        discount
        maximumLimit
        minimumLimit
        price1
        price2
        typeEcommerce
        type
      }
      sku
      stock
      stockBreak
      storeId
      store {
        name
        id
      }
      storeId
      variations {
        ecommerceId
        isDefault
        name
        percentage
      }
    }
  }
`

export const MUTATION_UPDATE_PRODUCT_STORE = gql`
  mutation UpdateStoreProduct($data: UpdateStoreProductInput!) {
    updateStoreProduct(data: $data) {
      id
    }
  }
`

export const MUTATION_CREATE_PRODUCT_STORE = gql`
  mutation CreateStoreProduct($data: CreateStoreProductInput!) {
    createStoreProduct(data: $data) {
      id
    }
  }
`
